import { authClient } from '../../../lib/connect/clients';
/**
 * Full tenant directory search for Assist resolution — does not apply the
 * picker UX slice (sharingApi.searchUsers caps query results at 10).
 */ async function listDirectoryUsers(query) {
    const response = await authClient.listUsersForSharing({
        query
    });
    return (response.users ?? []).map((user)=>({
            userId: user.id,
            email: user.email,
            name: user.name
        }));
}
/**
 * Resolve a signed-in platform user via the same tenant directory the Delivery
 * people pickers use (ListUsersForSharing), as the current user.
 */ export async function resolvePlatformUserId(params) {
    const existing = typeof params.user_id === 'string' && params.user_id.trim() || typeof params.userId === 'string' && params.userId.trim() || '';
    if (existing) {
        return {
            userId: existing
        };
    }
    const email = typeof params.user_email === 'string' && params.user_email.trim() || typeof params.userEmail === 'string' && params.userEmail.trim() || '';
    const name = typeof params.user_name === 'string' && params.user_name.trim() || typeof params.userName === 'string' && params.userName.trim() || '';
    const freeText = typeof params.user === 'string' && params.user.trim() !== '';
    const query = (freeText ? String(params.user).trim() : '') || email || name;
    if (!query) {
        return {};
    }
    const users = await listDirectoryUsers(query);
    if (!users.length) {
        return {
            error: `No tenant user matched "${query}"`
        };
    }
    const lower = query.toLowerCase();
    const exactEmails = users.filter((u)=>u.email?.toLowerCase() === lower);
    if (exactEmails.length === 1) {
        const exactEmail = exactEmails[0];
        return {
            userId: exactEmail.userId,
            label: exactEmail.name?.trim() || exactEmail.email
        };
    }
    if (exactEmails.length > 1) {
        return {
            error: `Ambiguous user "${query}" — ${exactEmails.length} exact email matches; pass user_id`
        };
    }
    const exactNames = users.filter((u)=>u.name?.trim().toLowerCase() === lower);
    if (exactNames.length === 1) {
        const exactName = exactNames[0];
        return {
            userId: exactName.userId,
            label: exactName.name?.trim() || exactName.email
        };
    }
    if (exactNames.length > 1) {
        return {
            error: `Ambiguous user "${query}" — ${exactNames.length} exact name matches; pass user_email or user_id`
        };
    }
    // Single fuzzy match is only safe for free-text `user`, not explicit email/name.
    if (users.length === 1 && freeText) {
        const only = users[0];
        return {
            userId: only.userId,
            label: only.name?.trim() || only.email
        };
    }
    if (!freeText) {
        return {
            error: `No tenant user exactly matched "${query}"`
        };
    }
    return {
        error: `Ambiguous user "${query}" — ${users.length} matches; pass user_email or user_id`
    };
}
